import { constructorSchema, type AbstractApiSchema } from "vue-utils"
import { SystemRole, getRolePriority } from "./SystemRole"

export interface UserDetails {
	guid: string
	firstName: string
	lastName: string
	emailAddress: string
	role: SystemRole
}

export class User implements UserDetails {
	guid: string
	firstName: string
	lastName: string
	emailAddress: string
	role: SystemRole

	static readonly Schema: AbstractApiSchema<User> = constructorSchema(User)

	constructor(user: UserDetails) {
		this.guid = user.guid
		this.firstName = user.firstName
		this.lastName = user.lastName
		this.emailAddress = user.emailAddress
		this.role = user.role
	}

	get fullName(): string {
		return [this.firstName, this.lastName].filter((text) => !!text && text.trim().length > 0).join(" ")
	}

	atLeastHasRole(role: SystemRole): boolean {
		const ownPriority = getRolePriority(this.role)
		const rolePriority = getRolePriority(role)

		return ownPriority >= rolePriority
	}
}
